module.exports = __webpack_public_path__ + "static/media/BodyPostureFeedbackENG.10058fd8.vtt";